export const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null;

export const toRecordArray = (value: unknown): Record<string, unknown>[] =>
  Array.isArray(value) ? value.filter(isRecord) : [];

export const toOptionalString = (value: unknown): string | null =>
  typeof value === 'string' ? value : null;

export const toOptionalNumber = (value: unknown): number | null =>
  typeof value === 'number' ? value : null;

export const toOptionalBoolean = (value: unknown): boolean | null =>
  typeof value === 'boolean' ? value : null;
